import React from "react";
import { motion } from "framer-motion";

const HeaderSection = ({ colors, error, isVisible }) => {
  const titleVariants = {
    hidden: { 
      opacity: 0, 
      y: 50,
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.8, 
        ease: [0.25, 0.46, 0.45, 0.94],
      }
    }
  };

  const subtitleVariants = {
    hidden: { 
      opacity: 0, 
      y: 30,
    },
    visible: { 
      opacity: 0.8, 
      y: 0,
      transition: { 
        duration: 0.7, 
        ease: [0.25, 0.46, 0.45, 0.94],
        delay: 0.2
      }
    }
  };

  return (
    <div className="header-section">
      <motion.div 
        className="title-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={titleVariants}
      >
        <h2 className="display-5 fw-bold mb-3 achievement-title" style={{ color: colors.white }}>
          Our Achievements
        </h2>
      </motion.div>
      
      <motion.div 
        className="subtitle-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={subtitleVariants}
      >
        <h3 className="subtitle" style={{color: colors.white}}>
          Every statistic tells a story of dedication, innovation, and client success.
          Watch our achievements come to life!
        </h3>
      </motion.div>
      
      {error && (
        <div className="error-message">
          <p style={{ color: '#ff6b6b', fontSize: '0.9rem', fontStyle: 'italic' }}>
            Note: Using fallback data due to API connection issue
          </p>
        </div>
      )}
    </div>
  );
};

export default HeaderSection;